import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import {TranslateService} from '@ngx-translate/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Session } from 'protractor';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-loadexam',
  templateUrl: './loadexam.component.html',
  styleUrls: ['./loadexam.component.scss']
})
export class LoadexamComponent implements OnInit {

  public logo: any;

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    this.logo = "../../assets/ecitb.jpg";

    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0){
      var enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
      generalSvc.logoutUser(enetsecure);
    }

    //if (dataSvc.currentExamIndex == -1)
      //generalSvc.loginUser();

    if (dataSvc.currentExam().Session.TimeTakenInSeconds > 0)
      this.resumeExam();
    
    if (dataSvc.currentUser.Exams[dataSvc.currentExamIndex].Session.AssessmentFrontPageText == null || dataSvc.currentUser.Exams[dataSvc.currentExamIndex].Session.AssessmentFrontPageText == "")
      this.startExam();

    if(dataSvc.currentUser.Media.length > 0){
      let mediaSrc = dataSvc.currentUser.Media[0].Data
      if(!mediaSrc.startsWith('data:image'))
        mediaSrc = 'data:image/png;base64, ' + mediaSrc;

      this.logo = sanitizer.bypassSecurityTrustUrl(mediaSrc);
    }
  }

  ngOnInit() {
  }

  logout(){
    const enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
    localStorage.removeItem("tUsername");
    localStorage.removeItem("tPassword");
    this.generalSvc.logoutUser(enetsecure);
  }

  startExam() {
    this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].StatusText = "Started";
    var sessionId = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.SessionId;
    if(sessionId !== null && sessionId !== undefined && sessionId > 0){
      this.dataSvc.updateSessionStatus(sessionId, 3);
      this.dataSvc.updateScheduleCandidateStatus(sessionId, 3);
    }
    this.initiateTimer();
    this.resumeExam();
  }

  initiateTimer(){
    var timerMins = 0;
    var questions = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Questions;
    for(var q = 0; q < questions.length; q++){
      var question = questions[q].Question;
      if(question != null){
        var qTime = question.QuestionTime;
        if(qTime !== null){
          timerMins += qTime;
        }
      }
    }

    var adaptedTime = 0;
    var scheduleCandidate = this.dataSvc.currentUser.ScheduleCandidate;
    if(scheduleCandidate != null){
      if(scheduleCandidate.ExtraTime != null && scheduleCandidate.ExtraTime > 0){
        adaptedTime += scheduleCandidate.ExtraTime;
      }
    }

    timerMins += adaptedTime;
    
     var startTime = new Date();
     var endTime = new Date();
     endTime.setMinutes(endTime.getMinutes() + timerMins);
     endTime = new Date(endTime);

    if(this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted == null 
      || this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted == ""){
        this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted = startTime;
    }

    if(this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime == null
      || this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime == ""){
        this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime = endTime;
    }    
  }

  resumeExam() {
    this.generalSvc.launchExamQuestions();
    this.dataSvc.startSyncMethods();
  }
}
